import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoginService } from '../../services/login/login.service';
import { User } from '../../models/login/user';
import { Observable } from 'rxjs/Rx';
import { FormsModule } from '@angular/forms';
import { global } from '../../models/global';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  user: User;
  loginForm: FormGroup;
  display = 'none';
  emailaddress: string;
  pageName: any = {};
  public Username: string;
  ROOT_URL: string = "";
  loader: string = 'none';

  private IsUserValid: boolean = false;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private loginService: LoginService,
    private form: FormBuilder,
    public toastr: ToastrService) {
    let g: global = new global();
    this.ROOT_URL = g.getApiUrl();
  }

  ngOnInit(): void {
    this.loginForm = this.form.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  authenticateUser(formData: any) {
    if (formData.value.username.trim() == "") {
      this.toastr.error("Please enter user name.");
      return;

    }
    else if (formData.value.password.trim() == "") {
      this.toastr.error("Please enter password.");
      return;
    }
    else {
      this.loader = 'block';
      this.loginService.authenticateUser(formData)
        .subscribe((resData: any) => {
          if (resData.status) {
            localStorage.setItem('dsu_token', resData.data.token);
            localStorage.setItem('dsu_roleId', resData.data.roleId);
            localStorage.setItem('dsu_userId', resData.data.userID);
            localStorage.setItem('dsu_userName', resData.data.userName.trim());
            localStorage.setItem('dsu_roleCode', resData.data.roleCode);
            localStorage.setItem('dsu_roleName', resData.data.roleName.trim());
            localStorage.setItem('dsu_userType', resData.data.userType.trim());
            localStorage.setItem('dsu_isViewOnly', resData.data.isViewOnly);
            this.router.navigate(['DSU/Dashboard']);
          }
          else {
            this.toastr.error('Password is not valid.');
          }
          this.loader = 'none';
        }, error => {
          console.log(error);
           this.loader = 'none';
        }   );
       
    }
  }

  isValidUser(event: any) {
    let userName: string = event.target.value;
    if (userName.trim() != "") {
      this.loginService.validateUser(userName)
        .subscribe((response: any) => {
 
          if (!response.status) {
            this.IsUserValid = false;
            this.toastr.error(response.data.errorDescription);
            
          }
          else {
            this.IsUserValid = true;
          }
        }, error => {
          console.log(error);
        });
    }
    else {
      this.toastr.error("Please enter user name.");
    }
  }

  showForgotPassword() {
    let url: any;
    if (this.ROOT_URL.indexOf('dsu.fmcone.in') !== -1)
        url = 'https://cmaster.fmcone.in/ForgotPassword';
    else
        url = 'https://cmaster.uat.fmcone.in/ForgotPassword';


    window.open(url, "_blank");
}

}
